import { combineReducers } from 'redux';
import landingPage from './landingPage';
import language from './language';
import options from './options';
import orderInfo from './orderInfo';
import orderItems from './orderItems';
import page from './page';
import printerlessInfo from './printerlessInfo';
import reasons from './reasons';
import retailerSettings from './retailerSettings';
import returnReasonsMonitoring from './returnReasonsMonitoring';
import returnsSettings from './returnsSettings';
import addresses from './addresses';
import exchange from './exchange';
import returnOptions from './returnOptions';
import storeLocator from './storeLocator';
import restrictions from './restrictions';
import carrierPickup from './carrierPickup';
import photoUpload from './photoUpload';
import proposedPickup from './proposedPickup';
import refunds from './refunds';
import returnConfirmation from './returnConfirmation';
import returnItems from './returnItems';
import returnMethods from './returnMethods';
import returnSubmission from './returnSubmission';
import payments from './payments';
import stripe from './stripe';
import stripeWidget from './stripeWidget';
import localPickup from './localPickup';
import pickupAddon from './pickupAddon';
import addons from './addons';
import pickup from './pickup';
import analytics from './analytics';
import userPreferences from './userPreferences';
import multiOrders from './multiOrders';
import tooltip from './tooltip';
import orderService from './orderService';
import itemsPage from './itemsPage';
import claims from './claims';
import returnReasonSidebar from './returnReasonSidebar';
import appCta from './appCta';
import unevenExchanges from './unevenExchanges';
import resolutions from './resolutions';
import repairs from './repairs';

export default combineReducers({
  landingPage,
  language,
  options,
  orderInfo,
  orderItems,
  page,
  printerlessInfo,
  reasons,
  retailerSettings,
  returnOptions,
  returnReasonsMonitoring,
  returnsSettings,
  addresses,
  exchange,
  storeLocator,
  restrictions,
  carrierPickup,
  photoUpload,
  proposedPickup,
  refunds,
  returnConfirmation,
  returnItems,
  returnMethods,
  returnSubmission,
  payments,
  stripe,
  stripeWidget,
  localPickup,
  pickupAddon,
  addons,
  pickup,
  analytics,
  userPreferences,
  multiOrders,
  tooltip,
  orderService,
  itemsPage,
  claims,
  returnReasonSidebar,
  appCta,
  unevenExchanges,
  resolutions,
  repairs,
});
